<app-top-bar *ngIf="dataService.showTopBar"></app-top-bar>
<app-toast></app-toast>
<!-- <app-free-plan-upgrade-card></app-free-plan-upgrade-card> -->
<router-outlet></router-outlet>
<div class="update-toast" *ngIf="showUpdateToast && onHomePage" role="status" aria-live="polite">
  <span class="update-toast__text">A new version is available.</span>
  <button type="button" class="update-toast__action" (click)="updateVersion()">Update now</button>
  <button type="button" class="update-toast__close" aria-label="Dismiss" (click)="closeVersion()">&times;</button>
</div>


<!-- <div class="update-banner">
    <p>New version available. <a href="" (click)="updateVersion()">Update now</a></p>
  </div> -->
<!-- <div
    class="w-100 position-fixed top-0"
    style="z-index: 9999999"
    *ngIf="modalPwaPlatform === 'ANDROID' || modalPwaPlatform === 'IOS'"
  >
    <div
      class="alert alert-secondary m-2"
      style="background-color: rgb(255, 93, 93); color: #000"
    >
      <button
        type="button"
        class="btn-close position-fixed top-0 end-0 m-3"
        aria-label="Close"
        (click)="closePwa()"
      ></button>
      <div *ngIf="modalPwaPlatform === 'ANDROID'" (click)="addToHomeScreen()">
        Add this WEB app to home screen
      </div>
      <div *ngIf="modalPwaPlatform === 'IOS'">
        For best experience install this WEB app on your device, tap the "Menu" button
        <img
          src="../assets/safari_action_button_38x50.png"
          class="ios-menu m-0" style="width: 1rem;"
        />
        and then "Add to home screen" button
        <i class="bi bi-plus-square"></i>
      </div>
    </div>
  </div> -->
<div class="w-100 position-fixed bottom-0 app-install-banner" style="z-index: 999999999"
  *ngIf="showAppInstallBanner">
  <div class="alert alert-secondary m-2" style="color: #000; padding: 0.5rem;">

    <!-- Android -->
    <div *ngIf="modalPwaPlatform1 === 'ANDROID'">
      <div class="row" style="display: flex;
        align-items: center;">
        <div class="col-1">
          <button type="button" style="padding: 0px;" class="btn-close" aria-label="Close"
            (click)="closePwa1()"></button>
        </div>
        <div class="col-2">
          <img id="backgroundImage" style="    width: -webkit-fill-available;
            " src="/assets/app_logo.png" alt="Navbar Background Image" />
        </div>
        <div class="col-6">
          <p style="margin: 0px; font-weight: bold;">
            Only in the Picaggo App
          </p>
          <p style="margin: 0px;">
            Host, Collaborate and Share Events.
          </p>
        </div>
        <div class="col-3 p-0">
          <button mat-raised-button color="primary" (click)="checkForPlaystore()"
            style="background-image: linear-gradient(to right, #eb3349, #f45c43) !important;">Open</button>
        </div>
      </div>
    </div>
    <!-- iOS with Safari -->
    <div *ngIf="modalPwaPlatform1 === 'IOS'">
      <div class="row" style="display: flex;
        align-items: center;">
        <div class="col-1">
          <button type="button" style="padding: 0px;" class="btn-close" aria-label="Close"
            (click)="closePwa1()"></button>
        </div>
        <div class="col-2">
          <img id="backgroundImage" style="    width: -webkit-fill-available;
            " src="/assets/app_logo.png" alt="Navbar Background Image" />
        </div>
        <div class="col-6">
          <p style="margin: 0px; font-weight: bold;">
            Only in the Picaggo App
          </p>
          <p style="margin: 0px;">
            Host, Collaborate and Share Events.
          </p>
        </div>
        <div class="col-3 p-0">
          <button (click)="checkForAppstore()" mat-raised-button color="primary"
            style="background-image: linear-gradient(to right, #eb3349, #f45c43) !important;">Open</button>
        </div>
      </div>


    </div>
  </div>
</div>

<!-- Reserves scroll space equal to the fixed install banner above. Without it the
     banner permanently covers the last ~80px of every route's content — on a locked
     album that is exactly where the "Uploads are disabled" notice ends up. Mirrors
     the .fixed-btn-bar / .fixed-btn-bar-spacer pairing in event-detail. -->
<div class="app-install-banner-spacer" *ngIf="showAppInstallBanner"></div>

<!-- Persistent upload strip. Sitting here — a sibling of <router-outlet>, not
     inside a routed component — is the entire reason it survives navigation.
     Renders nothing at all unless a minimized upload is in flight, and the
     whole surface is off in production behind features.persistentUploadBanner. -->
<app-upload-banner
  *ngIf="uploadBannerEnabled"
  [class.has-install-banner]="showAppInstallBanner"></app-upload-banner>